import { generateProperUrl } from '../utils/tools';
import { Config } from './interface';

const config: Config = {
  header: {
    logo: 'favicon-yupoo.ico',
    content: '图片管家客服',
  },
  screen: {},
  serviceURL: generateProperUrl('service'),
  websocketURL: generateProperUrl('websocket'),
  bulletin: {
    content:
      '尊敬的客户，感谢您使用图片管家客服。为保证服务及时高效，请您描述遇到的问题，提供准确的用户名、有效的联系方式。',
    worktime:
      '工作时间：<br>' +
      '周二～周四  9:00-20:00<br>' +
      '周五～周一  9:00-18:00',
    helper: [
      {
        content: '帮助中心',
        url: 'https://x.yupoo.com/help',
      },
      {
        content: '视频教程',
        url: 'https://help.x.yupoo.com/categories',
      },
      {
        content: '智能客服',
        url: '/agent',
      },
      // {
      //   content: '电话：0571-81020203',
      // },
      {
        content: '邮件：faq@yupoo-inc.com',
      },
    ],
  },
};

export default config;
